// Cantidad de filas por página en TODA la app. Antes cada pantalla tenía la suya
// (Presupuestos 10, Finanzas 15, Clientes 18, Servicios/Ventas/Repuestos 20) y al
// pasar de una sección a otra la misma paginación traía cantidades distintas.
export const POR_PAGINA = 20;
